function n(n,e){return e%10==1&&e%100!=11?n[0]:2<=e%10&&e%10<=4&&(e%100<10||20<=e%100)?n[1]:n[2]}export{n as declineByCount};
